jQuery(function($){

	const $info = $('#modal-datepicker-sunday-info');

	$('input.booking_date_day, input.booking_to_date_day').on('change', function(e){
		const isCheckout = $(e.target).hasClass('booking_to_date_day');
		const prefix = isCheckout ? 'booking_to_date' : 'booking_date';

		const day	= parseInt($(`input.${prefix}_day`).val(), 10);
		const month = parseInt($(`input.${prefix}_month`).val(), 10);
		const year	= parseInt($(`input.${prefix}_year`).val(), 10);

		if (!day || !month || !year) return;

		const selectedDate = new Date(year, month - 1, day);
		const weekday = selectedDate.getDay(); // 0 = nedjelja, 5 = petak, 6 = subota

		console.log(`Promjena na ${isCheckout ? 'checkout' : 'checkin'} datumu: ${year}-${month}-${day}`);
		console.log('Weekday:', weekday);

		if (isCheckout && (weekday === 5 || weekday === 6)) {
			const nextSunday = new Date(selectedDate);
			if (weekday !== 0) {
				nextSunday.setDate(selectedDate.getDate() + (7 - weekday));
			}

			const newDay = String(nextSunday.getDate()).padStart(2, '0');
			const newMonth = String(nextSunday.getMonth() + 1).padStart(2, '0');
			const newYear = nextSunday.getFullYear();

			$(`input.booking_to_date_day`).val(newDay);
			$(`input.booking_to_date_month`).val(newMonth);
			$(`input.booking_to_date_year`).val(newYear);

			if ($info.length) {
				$info.addClass('z-index');
				setTimeout(() => $info.addClass('visible'), 100);
				$('body').addClass('mobile-nav-open');
			}

			// alert('Check-out mora biti u nedjelju. Datum je automatski prilagođen.');
		}
	});

	$('#modal-datepicker-sunday-info > .modal__bg, #modal-datepicker-sunday-info button').on('click', function() {
		if ($info.length) {
			$info.removeClass('visible');
			setTimeout(() => $info.removeClass('z-index'), 100);
			$('body').removeClass('mobile-nav-open');
		}
	});
});

// // Mobile navigation toggle button function
// $(".header .navbar-toggler").on("click", function () {
//   if ($("body").hasClass("mobile-nav-open")) {
//     // hide mobile nav
//     $(".site-navigation").toggleClass("site-navigation-open");
//     $("body").toggleClass("mobile-nav-open");
//     $(".header").toggleClass("mobile-nav-open");
    
//     setTimeout(function() {
//       $("header").toggleClass("mobile-nav-open-z-index");
//     }, 360); // sum of transition duration and a bit more for class removing proccessing
//   } else {
//     // display mobile nav
//     $("header").toggleClass("mobile-nav-open-z-index");

//     setTimeout(function() {
//       $(".site-navigation").toggleClass("site-navigation-open");
//       $("body").toggleClass("mobile-nav-open");
//       $(".header").toggleClass("mobile-nav-open");
//     }, 60);
//   }
// });

// // Adding class on scroll for colored header
// var heroHeight = 70;
// // if ($(".lft-section.homepage-hero").length) {
// //   heroHeight = $(".lft-section.homepage-hero").height();
// //   heroHeight = heroHeight / 2;
// // }
// function lft_header_classes_on_load_and_scroll() {
//   if ($('header').hasClass('transparent-header')) {
//     var scroll = $(window).scrollTop();
//     if (scroll >= heroHeight) {
//       $(".header").addClass("header-scrolled");
//       $('.header .navbar-btn-wrap .btn.d-llg-flex').removeClass('btn-light');
//     } else {
//       $(".header").removeClass("header-scrolled");
//       $('.header .navbar-btn-wrap .btn.d-llg-flex').addClass('btn-light');
//     }
//   }
// }

// $(window).on("scroll", function () {
//   if ($('header').hasClass('transparent-header')) {
//     lft_header_classes_on_load_and_scroll();
//   }
// });
// $(window).on("load", function() {
//   setTimeout(() => {
//     lft_header_classes_on_load_and_scroll();
//   }, 500);
// });

document.addEventListener('DOMContentLoaded', function () {
  const navbarToggler = document.querySelector('.header .navbar-toggler');
  const body = document.body;
  const header = document.querySelector('.header');
  const siteNav = document.querySelector('.site-navigation');

  if (navbarToggler && header && siteNav) {
    navbarToggler.addEventListener('click', function () {
      if (body.classList.contains('mobile-nav-open')) {
        siteNav.classList.toggle('site-navigation-open');
        body.classList.toggle('mobile-nav-open');
        header.classList.toggle('mobile-nav-open');
        setTimeout(function () {
          document.querySelector('header')?.classList.toggle('mobile-nav-open-z-index');
        }, 360);
      } else {
        document.querySelector('header')?.classList.toggle('mobile-nav-open-z-index');
        setTimeout(function () {
          siteNav.classList.toggle('site-navigation-open');
          body.classList.toggle('mobile-nav-open');
          header.classList.toggle('mobile-nav-open');
        }, 60);
      }
    });
  }

  const heroHeight = 70;
  const mainHeader = document.querySelector('header');
  const scrollBtn = document.querySelector('.header .navbar-btn-wrap .btn.d-llg-flex');

  function lft_header_classes_on_load_and_scroll() {
    if (mainHeader && mainHeader.classList.contains('transparent-header')) {
      const scroll = window.scrollY;
      if (scroll >= heroHeight) {
        mainHeader.classList.add('header-scrolled');
        // scrollBtn?.classList.remove('btn-light');
      } else {
        mainHeader.classList.remove('header-scrolled');
        // scrollBtn?.classList.add('btn-light');
      }
    }
  }

  window.addEventListener('scroll', lft_header_classes_on_load_and_scroll);

  window.addEventListener('load', function () {
    setTimeout(lft_header_classes_on_load_and_scroll, 500);
  });
});

// $.fn.isInViewport = function () {
//     let elementTop = $(this).offset().top;
//     let elementBottom = elementTop + $(this).outerHeight();
//     let viewportTop = $(window).scrollTop();
//     let viewportBottom = viewportTop + $(window).height();
//     return elementBottom > viewportTop && elementTop < viewportBottom;
// };

// $(window).on("load resize scroll", function () {
//     $('.animateOnEnter').each(function() {
//         if ( $(this).isInViewport() ) {
//             $(this).addClass('inView');
//         }
//     });
// });
document.addEventListener("DOMContentLoaded", () => {
  const elems = document.querySelectorAll('.animate-on-scroll');
  if (!('IntersectionObserver' in window)) {
    // fallback: prikaži odmah
    elems.forEach(el => el.classList.add('in-view'));
    return;
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting) {
        target.classList.add('in-view');
        io.unobserve(target);  // animiraj samo jednom
      }
    });
  }, {
    rootMargin: '0px 0px -15% 0px', // pokreće malo ranije
    threshold: 0
  });

  elems.forEach(el => io.observe(el));
});

// $('[data-toggle="scroll-to"]').click(function() {

//   var $this = $(this);

//   if ( $this.data('scroll-offset') == true ) {
//     var offset = $('.header').height();
//   } else {
//     var offset = 0;
//   }

//   if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
//     var target = $(this.hash);
//     target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
//     if (target.length) {
//       $('html, body').animate({
//         scrollTop: target.offset().top - offset
//       }, 1000);
//       return false;
//     }
//   }
// });
document.addEventListener('DOMContentLoaded', function () {
  const body = document.body;
  const header = document.querySelector('.header');
  const siteNav = document.querySelector('.site-navigation');
  
  document.querySelectorAll('[data-toggle="scroll-to"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      if (body.classList.contains('home')) {
        e.preventDefault();
      }

      if (body.classList.contains('mobile-nav-open')) {
        siteNav.classList.toggle('site-navigation-open');
        body.classList.toggle('mobile-nav-open');
        header.classList.toggle('mobile-nav-open');
        setTimeout(function () {
          document.querySelector('header')?.classList.toggle('mobile-nav-open-z-index');
        }, 360);
      }

      const useOffset = link.dataset.scrollOffset === 'true';
      const offset = useOffset ? (document.querySelector('.header')?.offsetHeight || 0) : 0;

      const currentPath = location.pathname.replace(/^\//, '');
      const targetPath = link.pathname.replace(/^\//, '');
      const isSamePage = currentPath === targetPath && location.hostname === link.hostname;

      if (isSamePage) {
        let target = document.querySelector(link.hash);
        if (!target) {
          target = document.querySelector('[name="' + link.hash.slice(1) + '"]');
        }

        if (target) {
          const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({
            top: top,
            behavior: 'smooth'
          });
        }
      }
    });
  });
});

// $(document).ready(function() {
// 	$("#skipper").click(function() {
// 		$('#mainContent').attr('tabIndex', -1).focus();
// 	})
// });
document.addEventListener('DOMContentLoaded', function () {
  const skipper = document.getElementById('skipper');
  const mainContent = document.getElementById('mainContent');

  if (skipper && mainContent) {
    skipper.addEventListener('click', function () {
      mainContent.setAttribute('tabindex', '-1');
      mainContent.focus();
    });
  }
});

// $(document).ready(function() {
// 	var width   = 981;
// 	var height  = 461;
// 	var left    = (screen.width / 2) - (width / 2);
// 	var top     = (screen.height / 2) - (height / 2);
// 	$('.js-share-link').click(function(e) {
// 		e.preventDefault();
// 		window.open(
// 		$(this).attr('href'),
// 		'',
// 		'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=' + width + ',height=' + height + ',top=' + top + ',left=' + left
// 		);
// 	});
// });
document.addEventListener('DOMContentLoaded', function () {
  const width = 981;
  const height = 461;
  const left = (screen.width / 2) - (width / 2);
  const top = (screen.height / 2) - (height / 2);

  const shareLinks = document.querySelectorAll('.js-share-link');

  shareLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      window.open(
        link.getAttribute('href'),
        '',
        'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,' +
        'width=' + width + ',height=' + height +
        ',top=' + top + ',left=' + left
      );
    });
  });
});
